export default __webpack_public_path__ + "static/media/dropdownArrow.e46594c0.svg";